<template>
  <div v-if="visible" class="fncz-overlay" @click.self="onCancel">
    <div class="fncz-dialog">
      <div class="fncz-title">
        <span>{{ dialogTitle }}</span>
        <span class="fncz-close" @click="onCancel">×</span>
      </div>
      <div class="fncz-body">
        <div v-if="configError" class="fncz-error">{{ configError }}</div>
        <div class="fncz-row">
          <label class="fncz-label">{{ yjflLabel }}：</label>
          <select v-model="form.FNCZYJFL" class="fncz-input" @change="onYJFLChange">
            <option value="">请选择</option>
            <option v-for="item in yjflOptions" :key="item.value" :value="item.value">{{ item.label }}</option>
          </select>
        </div>
        <div class="fncz-row">
          <label class="fncz-label">{{ ejflLabel }}：</label>
          <select v-if="ejflMode === 'select'" v-model="form.FNCZEJFL" class="fncz-input">
            <option value="">请选择</option>
            <option v-for="item in ejflOptions" :key="item.value" :value="item.value">{{ item.label }}</option>
          </select>
          <input v-else-if="ejflMode === 'input'" v-model="form.FNCZEJFL" type="text" class="fncz-input" placeholder="请输入二级分类">
          <input v-else type="text" class="fncz-input" value="" placeholder="请先选择一级分类" disabled>
        </div>
        <div class="fncz-row">
          <label class="fncz-label">{{ bcyjLabel }}：</label>
          <textarea v-model="form.FNCZBCYJ" class="fncz-input fncz-textarea" placeholder="可为空"></textarea>
        </div>
      </div>
      <div class="fncz-footer">
        <button type="button" class="fncz-btn" @click="onCancel">取消</button>
        <button type="button" class="fncz-btn fncz-btn-primary" :disabled="!!configError" @click="onConfirm">确定</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

//同一会话内复用已加载的配置
let fnczConfigCache = null;

export default {
  name: 'FnczSetDialog',
  props: {
    visible: { //是否显示
      type: Boolean,
      default: false,
    },
    patch: { //当前图斑（或审核信息对象）
      type: Object,
      default: null,
    },
    config: { //父组件传入的配置（优先使用），未传则自行加载
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: {
        FNCZYJFL: '',
        FNCZEJFL: '',
        FNCZBCYJ: '',
      },
      fnczConfig: null, //非农化处置配置，来自tableConfig/wthz.json的wthz_fncz节点
      configError: '',
    };
  },
  computed: {
    dialogTitle() {
      return (this.fnczConfig && this.fnczConfig.title) || '非农化处置设定';
    },
    yjflLabel() {
      return (this.fnczConfig && this.fnczConfig.yjflLabel) || '非农处置一级分类';
    },
    ejflLabel() {
      return (this.fnczConfig && this.fnczConfig.ejflLabel) || '非农处置二级分类';
    },
    bcyjLabel() {
      return (this.fnczConfig && this.fnczConfig.bcyjLabel) || '非农处置补充意见';
    },
    //一级分类选项（来自配置，可动态修改）
    yjflOptions() {
      return (this.fnczConfig && this.fnczConfig.yjfl) ? this.fnczConfig.yjfl : [];
    },
    //当前选中的一级分类配置项
    currYjflItem() {
      return this.yjflOptions.find(item => item.value === this.form.FNCZYJFL) || null;
    },
    //二级分类选项（由当前一级分类决定）
    ejflOptions() {
      return (this.currYjflItem && this.currYjflItem.ejfl) ? this.currYjflItem.ejfl : [];
    },
    //二级分类录入方式：select下拉、input手工输入、none未选一级分类
    ejflMode() {
      if (!this.form.FNCZYJFL) {
        return 'none';
      }
      return (this.currYjflItem && this.currYjflItem.ejflMode === 'input') ? 'input' : 'select';
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initForm();
        this.loadConfig();
      }
    },
  },
  created() {
    this.loadConfig();
  },
  methods: {
    async loadConfig() { //加载非农化处置配置，支持通过修改tableConfig动态配置
      if (this.config && this.config.yjfl && this.config.yjfl.length > 0) {
        this.fnczConfig = this.config;
        this.configError = '';
        return;
      }
      if (fnczConfigCache) {
        this.fnczConfig = fnczConfigCache;
        return;
      }
      try {
        //加时间戳避免浏览器缓存旧的配置文件
        const res = await axios.get('/tableConfig/wthz.json',{params:{_t:Date.now()}});
        const cfg = res.data ? res.data.wthz_fncz : null;
        if (!cfg || !cfg.yjfl || cfg.yjfl.length < 1) {
          this.configError = '未找到非农化处置配置（tableConfig/wthz.json 中的 wthz_fncz）。';
          console.error(this.configError);
          return;
        }
        fnczConfigCache = cfg;
        this.fnczConfig = cfg;
        this.configError = '';
      } catch (error) {
        this.configError = '加载非农化处置配置失败：' + error;
        console.error(this.configError);
      }
    },
    initForm() { //用当前图斑的数据初始化表单
      const p = this.patch || {};
      this.form = {
        FNCZYJFL: p.FNCZYJFL || '',
        FNCZEJFL: p.FNCZEJFL || '',
        FNCZBCYJ: p.FNCZBCYJ || '',
      };
    },
    onYJFLChange() { //切换一级分类后清空二级分类，避免残留不匹配的值
      this.form.FNCZEJFL = '';
    },
    onCancel() {
      this.$emit('close');
    },
    onConfirm() {
      if (this.configError) {
        return;
      }
      this.$emit('confirm', {
        FNCZYJFL: this.form.FNCZYJFL,
        FNCZEJFL: this.form.FNCZEJFL,
        FNCZBCYJ: this.form.FNCZBCYJ,
      });
    },
  },
};
</script>

<style scoped>
.fncz-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fncz-dialog {
  width: 420px;
  background-color: #f0f0f0;
  border: 1px solid #999;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  text-align: left;
}

.fncz-title {
  background-color: #e0e0e0;
  padding: 6px 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
}

.fncz-close {
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
}

.fncz-body {
  padding: 10px;
}

.fncz-error {
  color: #c41a1a;
  margin-bottom: 8px;
}

.fncz-row {
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
}

.fncz-label {
  width: 150px;
  line-height: 24px;
  flex-shrink: 0;
}

.fncz-input {
  flex: 1;
  height: 24px;
  padding: 0 4px;
  box-sizing: border-box;
}

.fncz-textarea {
  height: 70px;
  padding: 2px 4px;
  resize: vertical;
}

.fncz-footer {
  padding: 8px 10px;
  text-align: right;
  border-top: 1px solid #d0d0d0;
}

.fncz-btn {
  margin-left: 8px;
  padding: 2px 14px;
  cursor: pointer;
}

.fncz-btn-primary {
  background-color: #409eff;
  color: #fff;
  border: 1px solid #409eff;
}
</style>
